import storageReportMutations from "./mutations.js";
import storageReportActions from "./actions.js";
import storageReportGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: storageReportMutations,
  actions: storageReportActions,
  getters: storageReportGetters,
};
